import { render, staticRenderFns } from "./alto-wine-estate.vue?vue&type=template&id=8b3f760c&scoped=true"
import script from "./alto-wine-estate.vue?vue&type=script&lang=js"
export * from "./alto-wine-estate.vue?vue&type=script&lang=js"
import style0 from "./alto-wine-estate.vue?vue&type=style&index=0&id=8b3f760c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3f760c",
  null
  
)

export default component.exports